import * as React from 'react'
import styled from 'styled-components'
import { Close } from 'svgIcons'
import Button from '@app.components/Button'
import Modal, { IFModalProps } from 'app.components/Modal/Modal'
import { mobileBreakPoint } from 'app.styled/media'

interface AlreadyReportedModalProps extends IFModalProps {
  type: 'comment' | 'newsItem'
}

const AlreadyReportedModal: React.FC<AlreadyReportedModalProps> = ({
  onClose,
  type,
  ...props
}) => {
  return (
    <Modal onClose={onClose} {...props}>
      <StyledWrapper>
        <div className="close-btn" onClick={onClose}>
          <Close />
        </div>
        <div className="modal-sub-title">
          이미 신고한 {type === 'comment' ? '댓글' : '소식'}입니다.
        </div>
        <Button className="btn" onClick={onClose}>
          확인
        </Button>
      </StyledWrapper>
    </Modal>
  )
}

export default AlreadyReportedModal

const StyledWrapper = styled.div`
  width: 100%;
  max-width: 360px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;

  .close-btn {
    align-self: flex-end;
    color: #999999;
    cursor: pointer;
  }
  .modal-sub-title {
    font-size: 20px;
    margin: 20px 0 30px;
    width: 100%;
    text-align: center;
    font-weight: 500;
  }
  .btn {
    font-size: 16px;
    padding: 13px 34px;
    margin-bottom: 20px;
  }
  ${mobileBreakPoint} {
    max-width: 350px;
  }
`
